export default "__VITE_ASSET__QfBp0Ztk__"